import { render, staticRenderFns } from "./ScreenLaudoObstetricaDoppler.vue?vue&type=template&id=efee2678&lang=true&"
import script from "./ScreenLaudoObstetricaDoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoObstetricaDoppler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports